import { globals } from '@updater/angular-common';
const CDN_URL = globals.urls.cdn;

const mapStyle = [
  {
    featureType: 'administrative.country',
    stylers: [{ color: '#bababb' }],
  },
  {
    featureType: 'administrative.country',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry',
    stylers: [{ visibility: 'on' }],
  },
  {
    featureType: 'administrative.province',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.locality',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.neighborhood',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.land_parcel',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'landscape.man_made',
    stylers: [{ visibility: 'simplified' }, { color: '#e4e4e5' }],
  },
  {
    featureType: 'road',
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ visibility: 'simplified' }, { color: '#f5f5ff' }],
  },
  {
    featureType: 'road.local',
    stylers: [{ visibility: 'simplified' }, { color: '#f5f5ff' }],
  },
  {
    featureType: 'transit',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'water',
    stylers: [{ visibility: 'simplified' }, { color: '#aac7d6' }],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [{ visibility: 'simplified' }, { color: '#e4e4e5' }],
  },
];

export const pathDot = `${CDN_URL}/map-red-dot.png`,
  fromDot = `${CDN_URL}/map-marker-a.png`,
  toDot = `${CDN_URL}/map-marker-b.png`,
  getDynamicMapStyle = () =>
    new google.maps.StyledMapType(mapStyle, { name: 'updater' });
